// react documenation used: https://react.dev/learn
// ReactRouter documentation used : https://reactrouter.com/web/guides/quick-start
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const ProtectedRoute = ({ children }) => {
  const auth = useAuth();

  if (!auth.isAuthenticated) {
    // If the user is not authenticated from authContext file the user will be set back to the login page.
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
